import {React, Component} from 'react'
import {BrowserRouter as Router, Switch, Route, Link} from "react-router-dom";
import {Container, Row, Col} from 'react-bootstrap'

import Header from '../../components/Header/Header'
import pxgGif from '../../assets/pxg.gif'
import './Landing.css';


class Landing extends Component {
  constructor(props){
    super(props)
    this.state = {
    }
  }


  

  render(){
    return (
      <div className="Landing">
          <Header/>
          <Container style={{fontSize:"40px", fontWeight:"800", margin:"20px"}}>Pixelglyph Classification Project</Container>
          
       

          <div className="cols" style={{margin:"30px", display: "flex", flexWrap:"wrap", flex:"1"}}>
            <div style={{margin:"20px", marginBottom:"0px", width:"45%", minWidth:"400px"}}>
                  <img src={pxgGif} style={{ width:"80%", borderRadius:"5px"}}/>
            </div>
            <div style={{fontSize:"24px", margin:"20px", marginBottom:"0px", width:"45%", minWidth:"300px"}}>
              <p>
                  Welcome to the Pixelglyph Classification Project. This is a community driven project meant to classify/label the <a href="https://pixelglyphs.io">Pixelglyphs</a>. Participation will earn you an NFT badge. You do not need to own a Pixelglyph to participate.
              </p>
              <p>
                  Pixelglyphs are a set of 10,000 unique on-chain avatar NFTs created using a cellular automaton on the Ethereum blockchain.
                  As they were created at random during the minting process, there are no artificially induced features, labels, properties assigned during mint.
                  All features are subjectively observed. This project is meant to classify all Pixelglyphs and build a searchable index.
              </p>
                  
                  <Link style={{display:"block"}} to="/classify" ><button className="classify" >Classify →</button></Link>
            </div>
            
          </div>

         
      </div>
                              
    
    );
  
  }
}

export default Landing;
